//#region Util Imports

import * as _ from 'underscore'

//#endregion

//#region Angular Imports

import { StateService, StateDeclaration, TransitionPromise } from "@uirouter/angularjs";

//#endregion

import { i18n } from '../i18n/common.i18n'
import { OperatorLayoutSettings } from '../../../helpers/operator-layout-settings'
import { IUserSession } from '../../../helpers/user-session'
import { EventsNames } from '../../../helpers/events-names'
import { TypeHelper } from '../../../helpers'

//#region Asset Imports

import './sidebar-menu.scss'
import * as TEMPLATE from './sidebar-menu.tpl.html'

//#endregion

window['MenuItems'] = []

export class MenuItem {
    public active: boolean

    constructor(public icon: string, public name: string, public resource: string, public state: string, public order: number, public caption: string = '', public params: any = null) {
    }

    static addMenuItem(icon: string, name: string, resource: string, state: string, order: number = null, caption: string = '', params: any = null) {
        window['MenuItems'].push(new MenuItem(icon, name, resource, state, order, caption, params))
    }

    static getMenuItems(): MenuItem[] {
        return window['MenuItems']
    }

    static setMenuItems(items: MenuItem[]) {
        window['MenuItems'] = items
    }
}

interface SidebarMenuScope extends ng.IScope {
    groupsItem: MenuItem
    groupingLocationsTypesItem: MenuItem
    tasksTypesItem: MenuItem
    operatorGroupItem: MenuItem
    consumersTypesItem: MenuItem

    items: MenuItem[]

    active: StateDeclaration

    arrowIcon: string

    goToPage: (item: MenuItem) => void
    getMenuCaption: (item: MenuItem) => string
    isActive: (item: MenuItem) => boolean
}

export class SidebarMenuDirective implements ng.IDirective {
    lastSelectedModule: string = 'lastSelectedModule'

    scope = {
        small: '='
    }

    restrict = 'E'

    controller = ['$scope', '$timeout', '$state', 'userSession', ($scope: SidebarMenuScope, $timeout: ng.ITimeoutService, $state: StateService, userSession: IUserSession) => {
        $scope['i18n'] = i18n

        var refreshMenu = (items: MenuItem[]) => {
            $scope.groupsItem = _.find(items, item => item.name == "alarmGroups")
            $scope.groupingLocationsTypesItem = _.find(items, item => item.name == "groupingLocationsTypes")
            $scope.operatorGroupItem = _.find(items, item => item.name == "operatorGroup")
            $scope.tasksTypesItem = _.find(items, item => item.name == "tasksTypes")
            $scope.consumersTypesItem = _.find(items, item => item.name == "consumersTypes")

            items = items.filter(item => item.name != 'alarmGroups' && item.name !== 'groupingLocationsTypes' && item.name !== 'operatorGroup' && item.name !== 'tasksTypes' && item.name !== 'consumersTypes')
            $scope.items = items.sort((a, b) => {
                return ((a.order < b.order) ? -1 : ((a.order > b.order) ? 1 : 0));
            })

            if (window['config']['RTLSTATE'])
                $scope.arrowIcon = 'icon-arrow-right'
            else
                $scope.arrowIcon = 'icon-arrow-left'

            $timeout(() => {
                if ($scope.groupsItem) {
                    $scope.groupsItem.active = groupsActive
                }
                if ($scope.groupingLocationsTypesItem) {
                    $scope.groupingLocationsTypesItem.active = groupingLocationsTypesActive
                }
                if ($scope.operatorGroupItem) {
                    $scope.operatorGroupItem.active = operatorGroupActive
                }
                if ($scope.tasksTypesItem) {
                    $scope.tasksTypesItem.active = tasksTypesActive
                }
                if ($scope.consumersTypesItem) {
                    $scope.consumersTypesItem.active = consumersTypesActive
                }
            })
        }

        $scope.$on(EventsNames.REFRESH_MENU, () => {
            refreshMenu(window['MenuItems'])
        })

        $scope.$watch(() => {
            return window['MenuItems']
        }, () => {
            refreshMenu(window['MenuItems'])
        })

        let lastModule: any = OperatorLayoutSettings.getSetting(this.lastSelectedModule)
        let groupsActive: boolean
        let groupingLocationsTypesActive: boolean
        let operatorGroupActive: boolean
        let tasksTypesActive: boolean
        let consumersTypesActive: boolean

        if ($state.current.name == 'alarmGroups') {
            $scope.active = lastModule
            groupsActive = true
        } else if ($state.current.name == 'groupingLocationsTypes') {
            $scope.active = lastModule
            groupingLocationsTypesActive = true
        } else if ($state.current.name == 'operatorGroup') {
            $scope.active = lastModule
            operatorGroupActive = true
        } else if ($state.current.name == 'tasksTypes') {
            $scope.active = lastModule
            tasksTypesActive = true
        } else if ($state.current.name == 'consumersTypes') {
            $scope.active = lastModule
            consumersTypesActive = true
        }
        else {
            $scope.active = $state.current
            const activeParams = TypeHelper.clone($state.params)

            delete activeParams['#']

            $scope.active.params = activeParams
            groupsActive = false
            groupingLocationsTypesActive = false
            operatorGroupActive = false
            tasksTypesActive = false
            consumersTypesActive = false
        }

        OperatorLayoutSettings.setSetting(this.lastSelectedModule, { name: $scope.active.name, params: $scope.active.params })

        var goTimeout: ng.IPromise<void>, saveTimeout: ng.IPromise<void>

        $scope.goToPage = (item: MenuItem) => {
            if (item.name != $scope.active.name ||
                (item.name == "operators" && $scope.groupsItem != null && $scope.groupsItem.active) ||
                (item.name == "operators" && $scope.operatorGroupItem != null && $scope.operatorGroupItem.active) ||
                (item.name == "alarms" && $scope.groupsItem != null && $scope.groupsItem.active) ||
                (item.name == "groupingLocations" && $scope.groupingLocationsTypesItem != null && $scope.groupingLocationsTypesItem.active) ||
                (item.name == "tasks" && $scope.tasksTypesItem != null && $scope.tasksTypesItem.active) ||
                (item.name == "consumers" && $scope.consumersTypesItem != null && $scope.consumersTypesItem.active) ||
                item.params && $scope.active.params && item.name == $scope.active.name && !angular.equals(item.params, $scope.active.params)) {
                if (item.name != "alarmGroups" && item.name !== 'groupingLocationsTypes' && item.name !== 'operatorGroup' && item.name !== 'tasksTypes' && item.name !== 'consumersTypes') {
                    $scope.active = item
                    OperatorLayoutSettings.setSetting(this.lastSelectedModule, { name: $scope.active.name, params: $scope.active.params })

                    if ($scope.groupsItem) {
                        $scope.groupsItem.active = false
                    }

                    if ($scope.groupingLocationsTypesItem) {
                        $scope.groupingLocationsTypesItem.active = false
                    }

                    if ($scope.operatorGroupItem) {
                        $scope.operatorGroupItem.active = false
                    }

                    if ($scope.tasksTypesItem) {
                        $scope.tasksTypesItem.active = false
                    }

                    if ($scope.consumersTypesItem) {
                        $scope.consumersTypesItem.active = false
                    }
                }
                else {
                    if ($scope.groupsItem && item.name == "alarmGroups") {
                        $scope.groupsItem.active = true
                        if ($scope.operatorGroupItem != null && $scope.operatorGroupItem.active == true) {
                            $scope.operatorGroupItem.active = false
                        }
                    }

                    if ($scope.groupingLocationsTypesItem) {
                        $scope.groupingLocationsTypesItem.active = true
                    }

                    if ($scope.operatorGroupItem && item.name == "operatorGroup") {
                        $scope.operatorGroupItem.active = true
                        if ($scope.groupsItem != null && $scope.groupsItem.active == true) {
                            $scope.groupsItem.active = false
                        }
                    }

                    if ($scope.tasksTypesItem) {
                        $scope.tasksTypesItem.active = true
                    }

                    if ($scope.consumersTypesItem) {
                        $scope.consumersTypesItem.active = true
                    }
                }
                $scope.$root.$broadcast('moduleChanging')
                if (goTimeout) {
                    $timeout.cancel(goTimeout)
                }
                goTimeout = $timeout(() => {
                    $scope.$root.$broadcast('disableLoadingIndicator')

                    let promise: TransitionPromise = null
                    if (item.params)
                        promise = $state.go(item.state, item.params)
                    else
                        promise = $state.go(item.state)

                    promise.then(() => {
                        $scope.$root.$broadcast('enableLoadingIndicator')
                    })

                    if (saveTimeout) $timeout.cancel(saveTimeout)
                    saveTimeout = $timeout(() => {
                        userSession.saveOperatorLayoutSettings(0)
                    }, 5000)
                }, 400)
            }
        }

        $scope.getMenuCaption = (item: MenuItem) => {
            if (item.resource) {
                return i18n('Common', item.resource) + item.caption
            } else {
                return item.caption
            }
        }

        $scope.isActive = (item: MenuItem) => {
            if (item.params != undefined && $scope.active != undefined && $scope.active.params) {
                if (angular.equals(item.params, $scope.active.params) && $scope.active.name == item.name) {
                    if ($scope.active.name === 'alarms') {
                        return $scope.groupsItem == undefined || !$scope.groupsItem.active
                    } else if ($scope.active.name === 'groupingLocations') {
                        return $scope.groupingLocationsTypesItem == undefined || !$scope.groupingLocationsTypesItem.active
                    } else if ($scope.active.name === 'tasks') {
                        return $scope.tasksTypesItem == undefined || !$scope.tasksTypesItem.active
                    } else if ($scope.active.name === 'consumers') {
                        return $scope.consumersTypesItem == undefined || !$scope.consumersTypesItem.active
                    } else if ($scope.active.name === 'operators' && $scope.groupsItem != null && $scope.groupsItem.active) {
                        return $scope.groupsItem == undefined || !$scope.groupsItem.active
                    } else if ($scope.active.name === 'operators' && $scope.operatorGroupItem != null && $scope.operatorGroupItem.active) {
                        return $scope.operatorGroupItem == undefined || !$scope.operatorGroupItem.active
                    }

                    return true
                }

                return false
            }

            if ($scope.active != undefined && $scope.active.name == item.name || $scope.active == item.name) {
                if ($scope.active.name === 'alarms') {
                    return $scope.groupsItem == undefined || !$scope.groupsItem.active
                } else if ($scope.active.name === 'groupingLocations') {
                    return $scope.groupingLocationsTypesItem == undefined || !$scope.groupingLocationsTypesItem.active
                } else if ($scope.active.name === 'tasks') {
                    return $scope.tasksTypesItem == undefined || !$scope.tasksTypesItem.active
                } else if ($scope.active.name === 'consumers') {
                    return $scope.consumersTypesItem == undefined || !$scope.consumersTypesItem.active
                } else if ($scope.active.name === 'operators' && $scope.groupsItem != null && $scope.groupsItem.active) {
                    return $scope.groupsItem == undefined || !$scope.groupsItem.active
                } else if ($scope.active.name === 'operators' && $scope.operatorGroupItem != null && $scope.operatorGroupItem.active) {
                    return $scope.operatorGroupItem == undefined || !$scope.operatorGroupItem.active
                }

                return true
            }

            return false
        }
    }]

    template = TEMPLATE
    replace = true
}